import { Color } from 'theme/enums';

const DEFAULT_WARNING_LABELS = ['new', 'unstarted', 'requested', 'created', 'pending', 'inactive'];
const DEFAULT_PRIMARY_LABELS = ['started', 'in progress', 'in process', 'active'];
const DEFAULT_SUCCESS_LABELS = ['completed', 'finished', 'done', 'complete'];
const DEFAULT_DANGER_LABELS = ['on hold', 'cancelled', 'awaiting information'];

export const getStatusColorMap = (statuses: string[]) => {
  return statuses.reduce(
    (acc, status) => {
      acc[status] = (() => {
        if (DEFAULT_WARNING_LABELS.includes(status.toLowerCase())) {
          return Color.WARNING;
        }

        if (DEFAULT_PRIMARY_LABELS.includes(status.toLowerCase())) {
          return Color.PRIMARY;
        }

        if (DEFAULT_SUCCESS_LABELS.includes(status.toLowerCase())) {
          return Color.SUCCESS;
        }

        if (DEFAULT_DANGER_LABELS.includes(status.toLowerCase())) {
          return Color.DANGER;
        }

        return Color.NEUTRAL;
      })();

      return acc;
    },
    {} as Record<string, Color>
  );
};
